import React, { Component } from "react";
import App from "base-shell/lib";
import ReactGA from "react-ga";

import * as uuid from "uuid";

import _config from "./config";
import LiffProvider from "providers/Liff";
import {
  GA_IP,
  GA_trackId,
  GA_UTM_CAMPAIGN,
  GA_UTM_MEDIUM,
  GA_UTM_SOURCE,
  GA_UUID,
  liffId,
  stage,
} from "config/const";

import "styles/index.css";
import { getIp } from "methods/system";
import { setGAInLocalstorage } from "methods/ga";
import Loading from "providers/Loading";

ReactGA.initialize(GA_trackId, {
  debug: stage === "local",
  titleCase: false,
});

export default class Demo extends Component {
  state = {
    loaded: false,
    ip: undefined,
  };

  componentDidMount() {
    const ecid = localStorage.getItem(GA_UUID);
    if (!ecid) localStorage.setItem(GA_UUID, uuid.v4());

    const searchParams = new URLSearchParams(window.location.search);
    const ga_utm_source = searchParams.get(GA_UTM_SOURCE);
    const ga_utm_medium = searchParams.get(GA_UTM_MEDIUM);
    const ga_utm_campaign = searchParams.get(GA_UTM_CAMPAIGN);
    if (ga_utm_source)
      setGAInLocalstorage({ ga_utm_source, ga_utm_medium, ga_utm_campaign });

    getIp().then((data) => {
      if (!data.err && data.ip) localStorage.setItem(GA_IP, data.ip);
      this.setState({ loaded: true });
    });
  }

  render() {
    const { loaded } = this.state;
    return (
      <LiffProvider
        liffId={liffId}
        mock={stage === "local" ? require("config/mock").liff : undefined}
      >
        {loaded ? <App config={_config} /> : <Loading />}
      </LiffProvider>
    );
  }
}
